import { useEffect, useRef, useState } from "react";
import { CustomTabs } from "../../components/CustomTabs"
import { TitleBar } from "../../components/TitleBar"
import useAuth from "../../hook/useAuth";
import baseURL from "../../config/api";
import UsernameValidatedComponent from "../../components/UsernameValidatedComponent";
import { DoesEmailExist, DoesUserNameExist } from "../../services/Users";
import PasswordValidation from "../../components/PasswordValidation";
import EmailValidatedToCheckExistComponent from "../../components/EmailValidatedToCheckExistComponent";
import { PhoneNumberInput } from "../../components/PhoneNumberInput";
import axios from 'axios';
import { PleasewaitPopup } from "../../components/PleasewaitPopup";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { getChildInvitationByUserIdandEmail } from "../../services/Parent";
import { getClassInvitationUserIdandEmail } from "../../services/Class";
import { useNavigate } from "react-router-dom";


export const Settings = () => {
    const { auth, setAuth }: any = useAuth();
    const navigate = useNavigate();
    const [tabs, setTabs] = useState<any[]>([]);
    const [firstName, setFirstName] = useState<string>("");
    const [userData, setUserData] = useState<any>({});
    const [lastName, setLastName] = useState<string>("");
    const [userName, setUserName] = useState<string>("");
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [mobilPhoneNumber, setMobilePhoneNumber] = useState<string>("");
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [usernameTouched, setUsernameTouched] = useState<boolean>(false);
    const [emailTouched, setEmailTouched] = useState<boolean>(false);
    const [isValidPassword, setIsValidPassword] = useState<boolean>(false);
    const [bio, setBio] = useState<string>("");
    const [passwordTouched, setPasswordTouched] = useState<boolean>(false);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
    const [imagePath, setImagePath] = useState<string>("");
    const inputFileRef = useRef<HTMLInputElement>(null);
    const [uploadFileImg, setUploadFileImg] = useState<FileList | null>(null);
    const [allPendingInvitation, setAllPendingInvitations] = useState<any[]>([]);
    const [pendingInvitationDataLoaded, setPendingInvitationDataLoaded] = useState<boolean>(false);

    const hanbleTabChange = (index: number) => {
        setActiveIndex(index);
    }

    useEffect(() => {
        if (auth?.role && auth?.role === "Learner") {
            setTabs(["Profile", "Pending Invitations"])
        }
        else {
            setTabs(["Profile"])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth])

    useEffect(() => {
        const fetchPendingInvitations = async () => {
            try {
                setPendingInvitationDataLoaded(false);
                const [parentData, classData] = await Promise.all([
                    getChildInvitationByUserIdandEmail(auth?.id, auth?.emailAddress),
                    getClassInvitationUserIdandEmail(auth?.id, auth?.emailAddress)
                ]);

                const courseInvites = parentData?.map((item: any) => ({
                    ...item,
                    type: "parent",
                }));

                const classInvites = classData?.map((item: any) => ({
                    ...item,
                    type: "class"
                }));


                const merged = [...courseInvites, ...classInvites];

                setAllPendingInvitations(merged);
                setPendingInvitationDataLoaded(true);

            } catch (error) {
                console.error("Error:", error);
                setAllPendingInvitations([]);
                setPendingInvitationDataLoaded(true);
            }
        };
        if (auth?.id && auth?.role === "Learner" && activeIndex === 1) {
            fetchPendingInvitations();
        }
    }, [auth, activeIndex])

    useEffect(() => {
        if (auth?.id && activeIndex === 0) {
            setUploadFileImg(null);
            setPleaseWaitPopup(true)
            axios
                .get(`${baseURL}users/${auth?.id}`)
                .then((response) => {
                    setUserData(response.data);
                    setFirstName(response.data.firstName);
                    setLastName(response.data.lastName);
                    setUserName(response.data.userName);
                    setEmailAddress(response.data.emailAddress);
                    setPassword(response.data.password);
                    setMobilePhoneNumber(response.data.mobilPhoneNumber);
                    setImagePath(response.data.profilePic)
                    setBio(response.data.bio);
                    setPleaseWaitPopup(false);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    console.error(error);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth, activeIndex]);

    const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFiles = e.target.files as FileList;
        if (selectedFiles.length !== 0) {
            setUploadFileImg(selectedFiles);
        }
    };

    const getData = (accessToken: string, uploadedImagePath: string) => {
        const jsonData: any = jwtDecode(accessToken);
        const id = jsonData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"];
        const givenname = jsonData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"];
        const emailAddress = jsonData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
        const role = jsonData["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];

        Cookies.set("token-jj-rental-ui", accessToken, {
            expires: jsonData.exp
        });
        Cookies.set("role-elministry", Cookies.get("role-elministry") || '0', {
            expires: jsonData.exp,
        });
        Cookies.set("userId-elministry", id, {
            expires: jsonData.exp,
        });

        Cookies.set("profileImg-elministry", uploadedImagePath, {
            expires: jsonData.exp,
        });


        setAuth({ id, userName, givenname, emailAddress, role, accessToken, profileImage: uploadedImagePath });
        setPleaseWaitPopup(false);

    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);

        let uploadedImagePath = imagePath;

        if (uploadFileImg && uploadFileImg?.length > 0) {
            const formData = new FormData();
            formData.append("ImageFile", uploadFileImg[0]);

            try {
                const uploadRes = await axios.post(`${baseURL}commonFile/Upload`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                    withCredentials: false,
                });

                uploadedImagePath = uploadRes?.data;
                setImagePath(uploadedImagePath);
            } catch (err) {
                console.error("Image upload failed:", err);
            }
        }

        await axios
            .put(
                `${baseURL}AuthUser/UpdateUserProfile?userId${auth?.id}`,
                JSON.stringify({
                    ...userData,
                    id: parseInt(auth?.id),
                    firstName,
                    lastName,
                    password,
                    mobilPhoneNumber,
                    emailAddress,
                    profilePic: uploadedImagePath,
                    bio
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                getData(response.data, uploadedImagePath);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }

    return (
        <>
            <div className="p-4 min-h-screen">
                <TitleBar title="Settings" />

                <div className="w-full py-8">
                    <CustomTabs
                        tabs={tabs}
                        activeIndex={activeIndex}
                        onChange={(index) => hanbleTabChange(index)}
                    />

                    {activeIndex === 0 && (
                        <div className="w-full px-4">
                            <div className="mt-2 p-2">
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="w-full">
                                        <div>
                                            {uploadFileImg && uploadFileImg?.length > 0 && uploadFileImg?.item(0) ? (
                                                <img
                                                    className="w-[100px] h-[100px] rounded-sm"
                                                    alt="uploaded preview"
                                                    src={URL.createObjectURL(uploadFileImg?.item(0)!)}
                                                    onError={({ currentTarget }) => {
                                                        currentTarget.onerror = null;
                                                        currentTarget.src = "./images/profile-placeholder.png";
                                                    }}
                                                />
                                            ) : (
                                                imagePath && (
                                                    <img
                                                        className="w-[100px] h-[100px] rounded-sm"
                                                        alt="profileImg"
                                                        src={`${baseURL}commonFile/Get?name=${imagePath}`}
                                                        onError={({ currentTarget }) => {
                                                            currentTarget.onerror = null;
                                                            currentTarget.src = "./images/profile-placeholder.png";
                                                        }}
                                                    />
                                                )
                                            )}

                                            {/* Responsive Upload Section */}
                                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-4">
                                                <div>
                                                    <label className="text-xs font-medium text-gray-700">
                                                        Upload Profile Picture
                                                    </label>
                                                    <input
                                                        name="profilepic"
                                                        type="file"
                                                        accept="image/*"
                                                        className="block w-full rounded border border-gray-300 px-3 py-2 shadow-sm outline-none text-sm placeholder:text-gray-400 focus:ring-2 focus:ring-primary focus:ring-offset-1 mt-1 bg-transparent"
                                                        onChangeCapture={onFileChangeCapture}
                                                        ref={inputFileRef}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Responsive Form Grid */}
                                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                            {/* First Column */}
                                            <div className="space-y-4">
                                                <div>
                                                    <label className="block text-xs font-medium text-[#667085]">First Name</label>
                                                    <input
                                                        type="text"
                                                        className="w-full px-[8px] py-[8px] border rounded-md border-[#D0D0D0] outline-none focus:border-[#167AC3] text-sm text-[#1D2939] bg-transparent"
                                                        value={firstName}
                                                        placeholder="First Name"
                                                        onChange={(e) => setFirstName(e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                <EmailValidatedToCheckExistComponent
                                                    email={emailAddress}
                                                    setEmail={setEmailAddress}
                                                    getEmail={DoesEmailExist}
                                                    touched={emailTouched}
                                                    setTouched={setEmailTouched}
                                                    className={{
                                                        parentDiv: "",
                                                        label: "block text-xs font-medium text-[#667085]",
                                                        input:
                                                            "w-full px-[8px] py-[8px] border rounded-md border-[#D0D0D0] outline-none focus:border-[#167AC3] text-sm text-[#1D2939] bg-transparent",
                                                    }}
                                                />

                                                <UsernameValidatedComponent
                                                    userName={userName}
                                                    setUserName={setUserName}
                                                    getUsername={DoesUserNameExist}
                                                    touched={usernameTouched}
                                                    setTouched={setUsernameTouched}
                                                    className={{
                                                        parentDiv: "",
                                                        label: "block text-xs font-medium text-[#667085]",
                                                        input:
                                                            "w-full px-[8px] py-[8px] border rounded-md border-[#D0D0D0] outline-none focus:border-[#167AC3] text-sm text-[#1D2939] bg-transparent",
                                                    }}
                                                />

                                                {/* Desktop View Field */}
                                                <div className="block max-sm:hidden">
                                                    <label className="block text-xs font-medium text-[#667085]">Bio</label>
                                                    <textarea
                                                        rows={4}
                                                        className="w-full px-[8px] py-[8px] border rounded-md border-[#D0D0D0] outline-none focus:border-[#167AC3] text-sm text-[#1D2939] bg-transparent"
                                                        value={bio}
                                                        placeholder="Bio"
                                                        onChange={(e) => setBio(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            {/* Second Column */}
                                            <div className="space-y-4">
                                                <div>
                                                    <label className="block text-xs font-medium text-[#667085]">Last Name</label>
                                                    <input
                                                        type="text"
                                                        className="w-full px-[8px] py-[8px] border rounded-md border-[#D0D0D0] outline-none focus:border-[#167AC3] text-sm text-[#1D2939] bg-transparent"
                                                        value={lastName}
                                                        placeholder="Last Name"
                                                        onChange={(e) => setLastName(e.target.value)}
                                                        required
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-xs font-medium text-[#667085]">Mobile Number</label>
                                                    <PhoneNumberInput
                                                        name={"phoneNumber"}
                                                        value={mobilPhoneNumber}
                                                        setValue={setMobilePhoneNumber}
                                                        fontSize={"14px"}
                                                        required={true}
                                                    />
                                                </div>

                                                <PasswordValidation
                                                    password={password}
                                                    setPassword={setPassword}
                                                    isValid={isValidPassword}
                                                    setIsValid={setIsValidPassword}
                                                    touched={passwordTouched}
                                                    setTouched={setPasswordTouched}
                                                    className={{
                                                        parentDiv: "relative",
                                                        label: "block text-xs font-medium text-[#667085]",
                                                        input:
                                                            "w-full px-[8px] py-[8px] border rounded-md border-[#D0D0D0] outline-none focus:border-[#167AC3] text-sm text-[#1D2939] bg-transparent",
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Mobile View Field */}
                                        <div className="hidden max-sm:block mt-4">
                                            <label className="block text-xs font-medium text-[#667085]">Bio</label>
                                            <textarea
                                                rows={4}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-[#D0D0D0] outline-none focus:border-[#167AC3] text-sm text-[#1D2939] bg-transparent"
                                                value={bio}
                                                placeholder="Bio"
                                                onChange={(e) => setBio(e.target.value)}
                                            />
                                        </div>

                                        {/* Buttons */}
                                        <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                            <button
                                                type="submit"
                                                className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}

                    {(auth?.role === "Learner" && activeIndex === 1) && (
                        <div className="w-full px-4">
                            <div className="space-y-4 my-4">
                                {(pendingInvitationDataLoaded && allPendingInvitation.length > 0) && (
                                    allPendingInvitation?.map((item: any, index: number) => (
                                        <div key={index} className="flex items-center justify-between bg-white shadow rounded-lg p-4 border hover:shadow-md transition">
                                            <div className="flex items-center space-x-4">

                                                <img src="/images/class-img.png" alt="class-img" className="w-16 h-16 rounded-md" />



                                                <div>
                                                    <h3 className="font-semibold text-gray-800 uppercase">{
                                                        item?.type === "parent" ?
                                                            item?.courseName : item?.title}</h3>
                                                    {
                                                        item?.type === "class" && (
                                                            <p className="text-sm">
                                                                <span className="font-medium">Courses:</span>{" "}
                                                                <span className="text-primary">
                                                                    {item?.courseName}
                                                                </span>
                                                            </p>
                                                        )
                                                    }

                                                    <p className="text-sm">
                                                        <span className="font-medium">{item?.type === "parent" ? "Parent:" : "Instructor:"}</span>{" "}
                                                        <span className="text-red-500">{item?.type === "parent" ? item?.parentFirstName + " " + item?.parentLastName : item?.teacherName}</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex items-center space-x-3">
                                                <button
                                                    className="px-4 py-2 border rounded-md text-primary border-primary hover:bg-blue-50"
                                                    onClick={() => {
                                                        if (item.type === "parent") {
                                                            navigate(`/child-invitation/${item?.token}`, {
                                                                state: {
                                                                    invitationData: item
                                                                }
                                                            })
                                                        }
                                                        else {
                                                            navigate(`/class/${item?.joinCode}`, {
                                                                state: {
                                                                    invitationData: item
                                                                }
                                                            })
                                                        }
                                                    }}
                                                >
                                                    Open
                                                </button>
                                            </div>
                                        </div>
                                    ))
                                )

                                }
                                {
                                    !pendingInvitationDataLoaded && (
                                        <div className="flex items-center justify-center w-full p-2">
                                            <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                        </div>
                                    )
                                }

                                {
                                    (pendingInvitationDataLoaded && allPendingInvitation.length === 0) && (
                                        <div className="flex items-center justify-center w-full p-2">
                                            <span className="text-lg text-gray-400">No data found!</span>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>

    )
}